// extracted by mini-css-extract-plugin
export var defaultList = "grid-module--defaultList--LH005";
export var description = "grid-module--description--gK9bq";
export var featuresWrapper = "grid-module--featuresWrapper--son4j";
export var item = "grid-module--item--PglzU";
export var list = "grid-module--list--+LUVr";
export var listWithHover = "grid-module--listWithHover--F7uP5";
export var title = "grid-module--title--iF+6I";